import { Form } from "antd";
import VtInput from "../vt/base/vtinput";
import VtPasswordInput from "../vt/base/vtpasswordinput";

export default function FormInput(props: any) {
  type FieldTypes_employee = {
    first_name?: string;
    middle_name?: string;
    last_name?: string;
    personal_email?: string;
    work_email?: string;
    contact_number?: number;
    legal_entity?: string;
    sub_entity?: string;
    joining_date?: string;
    start_date?: string;
    end_date?: string;
    department?: string;
    employment_type?: string;
    designation?: string;
    location?: string;
    state_id?: string;
    city_id?: string;
    employee_code?: string;
    reporting_to?: string;
    business_unit?: string;
    time_type?: string;
    shift?: string;
    leave_plan?: string;
    holiday_list?: string;
    expense_policy?: string;
    probation_policy?: string;
    notice_policy?: string;
    annual_salary?: string;
    pay_group?: number;
    salary_structure?: number;
    effective_date?: string;
    bonus_type?: string;
    bonus_amount?: string;
    bonus_due_date?: string;
    source_of_hire?: string;
    recruited_by?: string;
    tax_regime?: string;
    client_date_of_joining?: string;
    releiving_date?: string;
    reason_to_decline?: string;
  };

  const getformfield = () => {
    switch (props.type?.toLowerCase()) {
        
      case "password":
        return <VtPasswordInput  {...props}/>

      default:
        return <VtInput {...props} />;
    }
  };

  return (
    <div>
      <Form.Item<FieldTypes_employee> {...props} rules={ props.rules} shouldUpdate >{getformfield()}</Form.Item>
    </div>
  );
}
